export default __webpack_public_path__ + "static/media/banner_img1.ca292282.gif";